// test992
(992 && 0);
